import * as d3 from 'd3'

export default {
  methods: {
    

    call_LINK(selection, d_, sn) {
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(`#RFQ_BG_${sn}`).transition().duration(100).attr('opacity', 1)
      })
      .on('mouseout', function() {
        d3.select(`#RFQ_BG_${sn}`).transition().duration(150).attr('opacity', 0)
      })
      .on('click', () => {
        this.link_Modal(d_)
      }) 
      
    }, 

    link_Modal(data) {

      let dataSource = {}

        Object.keys(this.keys).forEach(d=>{
          dataSource = {...dataSource, [d]: data[this.keys[d]]}
        })
          
        console.log('dataSource: ', dataSource)

        // Mapping the filter(value) to JsonProps in A/G 
        let request_ = this.getRequestColumnProps('request', dataSource, this.ColumnProps)
        if(!request_) return

        // set for filterString 
        let filterString_ = ''
        
        // if A/G filterString is exist, set request_.iFilters.filterString + filterString_
        if(request_.iFilters.filterString) {
          request_.iFilters.filterString += filterString_ ? ` AND ${filterString_} ` : ''
        } else {
          request_.iFilters.filterString = filterString_||''
        }

        // combine filterString and inputFilter &&& emit request-action
        request_ = {...request_,
          filters : {
            ...this.FilterValues,
            ...request_.filters,
          },
          iFilters: { 
            filterString : request_.iFilters.filterString||'',
            inputFilter : request_.iFilters.inputFilter,},
        }
        this.$emit('request-action', request_)
    },

  }
}